"use strict";

exports.__esModule = true;
exports.default = void 0;

var _toggle = require("./toggle");

var _plugins = require("../../utils/plugins");

var directives = {
  bToggle: _toggle.default
};
var _default = {
  install: function install(Vue) {
    (0, _plugins.registerDirectives)(Vue, directives);
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/toggle/index.js
// module id = 264
// module chunks = 0 3